import React from 'react';
import { UncontrolledCollapse, Button, CardBody, Card } from 'reactstrap';
import Kontaktizleti  from './kontaktizleti.js';

import { useTranslation } from 'react-i18next';

const Dubrovnik = (props) => {

const { t } = useTranslation();

  return (
  	<div>
      
            <div className="container"> 
            <div>
              <img className="logo" src="slike/logo.png" alt="logo"/>
          </div>
              <div id="carouselExampleIndicators" className="carousel slide " data-ride="carousel">
                <ol className="carousel-indicators">
                  <li data-target="#carouselExampleIndicators" data-slide-to="0" className="active"></li>
                  <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
                  <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
                </ol>
                <div className="carousel-inner">
                  <div className="carousel-item active">
                    <img className="d-block w-100" src="slike/izleti/izleti/dubrovnik1.jpg" alt="First slide"/>
                  </div>
                  <div className="carousel-item">
                    <img className="d-block w-100" src="slike/izleti/izleti/dubrovnik2.jpg" alt="Second slide"/>
                  </div>
                  <div className="carousel-item">
                    <img className="d-block w-100" src="slike/izleti/izleti/dubrovnik3.jpg" alt="Third slide"/>
                  </div>
                </div>
                <a className="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
                  <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                  <span className="sr-only"></span>
                </a>
                <a className="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
                  <span className="carousel-control-next-icon" aria-hidden="true"></span>
                  <span className="sr-only"></span>
                </a>
              </div>
              <div className="text">
                <h2 className="h2izlet">{ t('dubrovnik.dubrovnik-title') }</h2>
                <div>
                  <Button id="opcenito" className="morebtn" >{ t('dubrovnik.dubrovnik-Overview-title') }</Button>
                    <UncontrolledCollapse toggler="#opcenito">
                      <Card>
                        <CardBody>
                          <p>{ t('dubrovnik.dubrovnik-Overview-text') }</p>
                      </CardBody>
                    </Card>
                  </UncontrolledCollapse>
                  </div>
                <hr className="line"/>
                <div>
                  <Button id="ukljuceno" className="morebtn">{ t('dubrovnik.dubrovnik-title-2') }</Button>
                    <UncontrolledCollapse toggler="#ukljuceno">
                      <Card>
                        <CardBody>
                <ul>
                  <li>{ t('dubrovnik.dubrovnik-list-1') }</li>
                  <li>{ t('dubrovnik.dubrovnik-list-2') }</li>
                  <li>{ t('dubrovnik.dubrovnik-list-3') }</li>
                  <li>{ t('dubrovnik.dubrovnik-list-4') }</li>
                  <li>{ t('dubrovnik.dubrovnik-list-5') }</li>
                  <li>{ t('dubrovnik.dubrovnik-list-6') }</li>
                  <li>{ t('dubrovnik.dubrovnik-list-7') }</li>
                  <li>{ t('dubrovnik.dubrovnik-list-8') }</li>
                  <li>{ t('dubrovnik.dubrovnik-list-9') } </li>
                  <li>{ t('dubrovnik.dubrovnik-list-10') } </li>
                </ul>
                      </CardBody>
                    </Card>
                  </UncontrolledCollapse>
                </div>
                <hr className="line"/>
                <div>
                  <Button id="odlazak" className="morebtn">{ t('dubrovnik.dubrovnik-title-3') }</Button>
                    <UncontrolledCollapse toggler="#odlazak">
                      <Card>
                        <CardBody>
                          <p>{ t('dubrovnik.dubrovnik-dubrovnik-text-2') }
                          </p>
                          </CardBody>
                    </Card>
                  </UncontrolledCollapse>
                </div>
                <hr className="line"/>

                <div>
                  <Button id="ulaznica" className="morebtn">{ t('dubrovnik.dubrovnik-title-4') }</Button>
                    <UncontrolledCollapse toggler="#ulaznica">
                      <Card>
                        <CardBody>
                          <p>
                          { t('dubrovnik.dubrovnik-price-list-1') } 
                          </p>
                          <ul>
                            <li>{ t('dubrovnik.dubrovnik-price-list-2') } </li>
                            <li>{ t('dubrovnik.dubrovnik-price-list-3') } </li>
                            <li>{ t('dubrovnik.dubrovnik-price-list-4') } </li>
                          </ul>
                          
                        </CardBody>
                    </Card>
                  </UncontrolledCollapse>
                </div>
                <hr className="line"/>

                <div>
                  <Button id="itinerar" className="morebtn">{ t('dubrovnik.dubrovnik-title-5') }</Button>
                    <UncontrolledCollapse toggler="#itinerar">
                      <Card>
                        <CardBody>
                          <p>{ t('dubrovnik.dubrovnik-itinerar-txt-1') }</p>
                          <p>{ t('dubrovnik.dubrovnik-itinerar-txt-2') }</p>
                          <p>{ t('dubrovnik.dubrovnik-itinerar-txt-3') }</p>
                          <p>{ t('dubrovnik.dubrovnik-itinerar-txt-4') }</p>
                          <p>{ t('dubrovnik.dubrovnik-itinerar-txt-5') }</p>
                          <p>{ t('dubrovnik.dubrovnik-itinerar-txt-6') }</p>
                          <p>{ t('dubrovnik.dubrovnik-itinerar-txt-7') }</p>
                          <p>{ t('dubrovnik.dubrovnik-itinerar-txt-8') }</p>
                        </CardBody>
                    </Card>
                  </UncontrolledCollapse>
                </div>
                <hr className="line"/>

                <div>
                  <Button id="info" className="morebtn">{ t('dubrovnik.dubrovnik-title-6') }</Button>
                    <UncontrolledCollapse toggler="#info">
                      <Card>
                        <CardBody>
                           
                          <ul>
                            <li>{ t('dubrovnik.dubrovnik-info-txt-1') }</li>
                            <li>{ t('dubrovnik.dubrovnik-info-txt-2') }</li>
                            <li>{ t('dubrovnik.dubrovnik-info-txt-3') }</li>
                            <li>{ t('dubrovnik.dubrovnik-info-txt-4') }</li>
                            <li>{ t('dubrovnik.dubrovnik-info-txt-5') }</li>
                            <li>{ t('dubrovnik.dubrovnik-info-txt-6') }</li>
                            <li>{ t('dubrovnik.dubrovnik-info-txt-7') }</li>
                          </ul>
                          
                        </CardBody>
                    </Card>
                  </UncontrolledCollapse>
                </div>
                <hr className="line"/>
                <div>
                  <Button id="otkazivanje" className="morebtn">{ t('dubrovnik.dubrovnik-title-7') }</Button>
                    <UncontrolledCollapse toggler="#otkazivanje">
                      <Card>
                        <CardBody>
                           <p>
                          { t('dubrovnik.dubrovnik-cancel-txt') }
                          </p>
                        </CardBody>
                    </Card>
                  </UncontrolledCollapse>
                </div>
                <hr className="line"/>

                <Kontaktizleti izlet="Dubrovnik" />
                
              </div>
          </div>
    </div>
  );
}

export default Dubrovnik;

